import { ReactElement, ReactNode } from "react";

interface propsModal{
    title: string;
    messageBody: string;
    textButton?: string;
    iconElement?: ReactNode,
    isOpen: boolean,
    solicitudeNumber?: string,
    onClose?: () => void,
    onAction?: () => void
} 

const ModalMessage = ({isOpen, title, messageBody, textButton, iconElement,solicitudeNumber, onAction, onClose, ...props}:propsModal) => {

    const clickHandler = () =>{
        if(onAction){
            onAction();
        }else{
            onClose && onClose();
        }
        
    }

    const renderListMessage = (messagesBody :string):ReactElement  => {
        const listMessage = messagesBody.split("\\n");

        let outPutHTML: ReactElement = (<p></p>);
        if(listMessage.length > 1){
            outPutHTML = (<ul className="pl-[20px] text-left">{listMessage.map((message:string) => ( 
                                            message && <li className={message.trim().startsWith("-")?"leading-[27px]":""}>{message}</li>
                                        )
                                        )}</ul>)
        }else{
            outPutHTML = (<p>{listMessage[0]}</p>)
        }

        return outPutHTML;
    }

    

    return (
        isOpen && <> <div className="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>
        <div className="z-10 sm:max-w-[60%] lg:max-w-[35%] w-[100%] lg:min-w-[200px] fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 ">
                    <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all py-7 sm:my-8 sm:w-full sm:max-w-lg">
                        {!textButton && <span className="block absolute right-[3%] top-[3%] font-[600] bg-brand-grayscale-200 rounded-[10px] px-[10px] py-[5px] 
                        text--brand-grayscale-900 cursor-pointer" onClick={clickHandler}>X</span>}
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            
                                {iconElement && <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100 sm:size-10">
                                    {iconElement}
                                </div>}
                                <div className="lg:mt-4 md:text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 className="text-base font-semibold text-gray-900 text-center" id="modal-title">{title}</h3>
                                    <p className="text-center">{solicitudeNumber && `Solicitud N° ${solicitudeNumber}`}</p>
                                    <div className="mt-3">
                                        <div className="text-sm text-gray-500 text-center">
                                        
                                            {
                                            
                                            messageBody && renderListMessage(messageBody)
                                            }</div>
                                    </div>
                                </div>
                           
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            {textButton && <button type="button" onClick={clickHandler} {...props} className="cursor-pointer mx-auto inline-flex w-full justify-center rounded-md bg-[#E02667] px-5 py-3 text-sm font-semibold text-white shadow-xs hover:bg-red-500 sm:w-auto">
                                {textButton}
                            </button>}
                        </div>
                    </div>
                </div>
            
        </div>
        </>
    )

}

export default ModalMessage;